module.exports = __webpack_public_path__ + "img/Fortentwickelter_Brand.4da5bac8.svg";